import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  as?: 'article' | 'div' | 'section';
}

const Card: React.FC<CardProps> = ({ children, className = '', as = 'article', ...props }) => {
  const Tag = as;
  return (
    <Tag className={className} {...props}>
      {children}
    </Tag>
  );
};

export default Card;

